import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createAABInstallation: {
        method: 'POST',
        url: `${BASE_PATH_API}/v2/lockboxprocessing/allianceassociationbank/installations`
    },
    getAABCredentials: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/allianceassociationbank/credentials`
    },
    patchAABCredentials: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/lockboxprocessing/allianceassociationbank/credentials/:id`
    },
    getAvailability: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/allianceassociationbank/availability`
    },
    getAABImportStatuses: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/allianceassociationbank/imports/status`
    },
    getAABSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/lockboxprocessing/allianceassociationbank/settings`
    },
    updateAABSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v2/lockboxprocessing/allianceassociationbank/settings`
    },
    downloadAABMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/allianceassociationbank/exports/members`,
        responseType: 'blob',
        transformResponse: function transformResponse(response, headers) {
            const contentDisposition = headers.get('content-disposition')
                ? headers.get('content-disposition').split('filename=')
                : [];

            return {
                data: response,
                filename: contentDisposition && contentDisposition.length > 1
                    ? contentDisposition[contentDisposition.length - 1]
                    : null
            };
        }
    },
    downloadAABAssociations: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/allianceassociationbank/exports/associations`,
        responseType: 'blob',
        transformResponse: function transformResponse(response, headers) {
            const contentDisposition = headers.get('content-disposition')
                ? headers.get('content-disposition').split('filename=')
                : [];

            return {
                data: response,
                filename: contentDisposition && contentDisposition.length > 1
                    ? contentDisposition[contentDisposition.length - 1]
                    : null
            };
        }
    },
    getIdAssignmentSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/idsettings`
    },
    updateGeneralSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/lockboxprocessing/generalsettings`
    },
    getImportStatuses: {
        method: 'GET',
        url: `${BASE_PATH_API}/lockboxprocessing/imports/statuses`
    }
};

export function LockboxProcessingApi() {
    return createActions(actions);
}
